<template>
  <div id="home" v-cloak>
    <el-container>
      <el-header height="45px" class="none">
        <el-menu
          class="navbar"
          :default-active="activeMenu"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item v-for="m in menus" v-bind:key="m.index" :index="m.index">{{ m.title }}</el-menu-item>
          <el-submenu index="card" class="right">
            <template slot="title">
              <i class="fa fa-user-circle fa-fw fa-lg"></i>
            </template>
            <div class="account-card">
              <div class="name">{{ $store.getters.loginStatus.nickname }}</div>
              <span class="loginId">@{{ $store.getters.loginStatus.username }}</span>
              <div class="belonging">{{ $store.getters.loginStatus.role_name }}</div>
            </div>
            <el-menu-item index="change-profile">プロフィール変更</el-menu-item>
            <el-menu-item index="change-password">パスワード変更</el-menu-item>
            <el-menu-item index="logout">ログアウト</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main class="main">
        <router-view/>
      </el-main>
    </el-container>
    <div class="user-profile">
      <el-dialog
        class="user-proflie-dialog"
        title="プロフィールの変更"
        :visible.sync="profileDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <el-form
          :ref="profileDialog.ref"
          :model="profileDialog.form"
          label-width="150px"
          :rules="profileDialog.rules"
          auto-complete="off"
          @submit.prevent.native="handleUpdateUserProfile(profileDialog)"
        >
          <el-form-item label="ニックネーム" prop="nickname">
            <el-input v-model="profileDialog.form.nickname" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <el-alert
          v-if="profileDialog.isAlert"
          :title="profileDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleUpdateUserProfile(profileDialog)"
            :loading="profileDialog.loading"
          >OK</el-button>
          <el-button @click="profileDialog.visible=false">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  name: "Home",
  data() {
    return {
      menus: [],
      profileDialog: {
        endpointUrl: "/api/accounts/profile/",
        rules: {
          nickname: [
            {
              required: true,
              message: "ニックネームを入力してください",
              trigger: "blur"
            }
          ]
        },
        visible: false,
        ref: "profileDialogForm",
        form: {
          nickname: ""
        },
        no_assigned_apps: [],
        loading: false,
        errorMessage: "",
        isAlert: false
      }
    };
  },
  computed: {
    activeMenu: function() {
      let m = this.$route.path
        .split("/")
        .slice(0, 2)
        .join("");
      return m;
    },
    belonging: function() {
      if (Array.isArray(this.$store.getters.loginStatus.departments)) {
        return this.$store.getters.loginStatus.departments.join(",");
      }
      return "";
    }
  },
  beforeRouteEnter(route, redirect, next) {
    axios.get("/api/accounts/profile").then(response => {
      store.dispatch("updateLoginStatus", response.data);
      next();
    });
  },
  created() {
    axios.get("/api/accounts/menus/").then(response => {
      this.menus = response.data;
    });
  },
  methods: {
    changePassword() {
      this.$router.push({ name: "changePassword" });
    },
    logout() {
      axios.get("/api/accounts/logout/").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    handleSelect(key) {
      if (key === "logout") {
        this.logout();
        return false;
      } else if (key === "change-password") {
        this.changePassword();
        return false;
      } else if (key === "change-profile") {
        axios.get(this.profileDialog.endpointUrl).then(response => {
          this.profileDialog.form = response.data;
          this.profileDialog.loading = false;
          this.profileDialog.isAlert = false;
          this.profileDialog.errorMessage = "";
          this.profileDialog.visible = true;
        });
        return false;
      }

      this.$router.push({ name: key });
    },

    handleUpdateUserProfile(dialog) {
      dialog.loading = true;
      dialog.errorMessage = "";
      dialog.isAlert = false;
      let ref = this.$refs[dialog.ref];
      ref.validate(valid => {
        if (valid) {
          axios
            .put(dialog.endpointUrl, dialog.form)
            .then(response => {
              dialog.loading = false;
              dialog.visible = false;
              ref.resetFields();
              store.dispatch("updateLoginStatus", response.data);
            })
            .catch(error => {
              console.log(error);
              dialog.isAlert = true;
              dialog.loading = false;
              dialog.errorMessage = "不明なエラーが発生しました。";
            });
        }
      });
    }
  }
};
</script>

<!-- <style lang="css" >
html,
body,
section,
#home {
  overflow: hidden;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
  min-height: 100%;
  height: 100%;
}

[v-cloak] {
  visibility: hidden;
}
.account-card {
  vertical-align: middle;
  float: none;
  border-bottom: solid 1px #ddd;
  margin: 0px 4px 4px 4px;
  color: #012c63;
  border-radius: 4px;
  background-color: #fff;
  .name,
  .loginId,
  .belonging {
    padding: 4px;
  }
  .name {
    font-size: 14px;
  }
  .loginId,
  .belonging {
    font-size: 12px;
  }
  .belonging {
  }
}

.el-menu-item.right,
.el-submenu.right {
  float: right !important;
}

.navbar {
  height: 45px;
  line-height: 45px;
  .title {
    margin-left: 16px;
    color: #ffd700;
    font-size: 20px;
    font-weight: 500;
  }
  .el-submenu__title i {
    color: #bfcbd9;
  }
  .el-menu-item:hover {
    /*background-color: #356097 !important;*/
  }
  .el-menu-item,
  .el-submenu,
  .el-submenu .el-submenu__title {
    height: 45px !important;
    line-height: 45px !important;
  }
  .el-menu-item.is-active {
    border-bottom-width: 4px;
  }
}

.el-header {
  padding: 0 !important;
}

.el-main {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  overflow: auto;
}

.el-table td,
.el-table th {
  padding: 0px;
  .cell {
    padding: 4px;
  }
}

.el-alert {
  margin-bottom: 8px;
}

/* element のdialogを使った削除確認メッセージダイアログの幅を狭くする */
.message-box .el-dialog {
  width: 30%;
}

.fg-success {
  color: #67c23a;
  font-weight: bold;
}

.fg-danger {
  color: #f56c6c;
  font-weight: bold;
}
</style> -->
